import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";

import { CoreFlightSteps } from "@b2bportal/core-utilities";
import {
  FilterDialog,
  Filters,
  FlightList,
  FlightListGridFilter,
  FlightShopTitle,
  FlightSummary,
  FlightSummaryLoading,
  Sort,
} from "@tenant/flights";

import { Page } from "@tenant/ui";
import clsx from "clsx";
import { useFlightSlot } from "../../slots";
import defaultStyles from "./ReturnPage.module.scss";
import type { ReturnPageProps } from "./types";

const COMPONENT_KEY = CoreFlightsComponent.ReturnPage;
export const ReturnPage = ({
  children,
  className,
  context,
  handlers,
  text,
}: ReturnPageProps) => {
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const FlightSlot = useFlightSlot();

  const {
    flightList,
    tripDetails,
    airports,
    origin,
    tripCategory,
    sortOption,
  } = context;
  const { handleSortChange, handleFareSelect, handleChooseFare } = handlers;

  return (
    <Page
      title={text.pageTitle}
      subtitle={text.subtitle}
      className={clsx(block, className)}
    >
      <div className={cn("container")}>
        <div className={cn("search")}>
          <FlightSlot.FlightShopSearch />
        </div>
        <div className={cn("filter")}>
          <Filters sliceIndex={1} />
        </div>
        <FlightSlot.FlightShopBreadcrumbs
          className={cn("breadcrumbs")}
          currentStep={CoreFlightSteps.RETURN}
        />
        {tripDetails == null ? (
          <FlightSummaryLoading className={cn("flight-summary-loading")} />
        ) : (
          <div className={cn("flight-summary-container")}>
            <FlightSummary
              tripDetails={tripDetails}
              airports={airports}
              sliceIndex={0} //Show summary of departure flight
              className={cn("flight-summary")}
            />
          </div>
        )}

        <FlightShopTitle
          className={cn("title-container")}
          tripCategory={tripCategory}
          destination={origin}
        />

        <div className={cn("sort")}>
          <Sort value={sortOption} handleSortChange={handleSortChange} />
        </div>
        <div className={cn("all-filters")}>
          <FilterDialog sliceIndex={1} />
        </div>

        <FlightListGridFilter className={cn("grid-filter")} />
        <div className={cn("flight-list-container")}>
          <FlightList
            flightList={flightList}
            sliceIndex={1}
            onFareSelect={handleFareSelect}
            goToNextStep={handleChooseFare}
            className={cn("flight-list")}
          />
        </div>
        {children}
      </div>
    </Page>
  );
};
